function validateNotify( event ){
  return (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) )
}

function validateTel( event ){
  return (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) )
}


function validateEngTextNoSpace(event){
  return (!/[.A-Za-z0-9_@]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) )
}

function validateText(event){
  return (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) )
}

export  { validateNotify, validateEngTextNoSpace, validateText, validateTel }